import { documentReady } from '@utils/toolbox';
import { pricehunter } from '@module/PriceHunter/PriceHunter';
documentReady(() => {
	pricehunter.init();
});
